"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Checkbox = void 0;
const styled_1 = __importDefault(require("@emotion/styled"));
const ui_theme_1 = require("@kyruus/ui-theme");
const Checkbox_1 = __importDefault(require("@mui/material/Checkbox"));
exports.Checkbox = (0, styled_1.default)(Checkbox_1.default) `
  &.MuiCheckbox-colorSecondary {
    padding: 0;
    color: ${(0, ui_theme_1.fromTheme)('color_checkbox')};
    &:hover {
      color: ${(0, ui_theme_1.fromTheme)('color_border_secondary')};
      background-color: transparent;
    }
    &.Mui-disabled {
      & .MuiSvgIcon-root {
        fill: ${(0, ui_theme_1.fromTheme)('color_border_disabled')};
        position: relative;
      }
      &:after {
        position: absolute;
        content: ' ';
        top: 0.25rem;
        left: 0.25rem;
        height: 1rem;
        width: 1rem;
        background-color: ${(0, ui_theme_1.fromTheme)('color_border_disabled')};
        border-radius: ${(0, ui_theme_1.fromTheme)('border_radius')};
      }
    }
    &.Mui-focusVisible {
      outline-color: blue;
      outline-color: -webkit-focus-ring-color;
      outline-style: auto;
      outline-width: 1px;
    }
  }
  &.MuiCheckbox-colorSecondary.MuiCheckbox-indeterminate {
    color: ${(0, ui_theme_1.fromTheme)('color_border_secondary')};
    &:hover {
      color: ${(0, ui_theme_1.fromTheme)('color_border_emphasis')};
      background-color: transparent;
    }
  }
  &.MuiCheckbox-colorSecondary.Mui-checked {
    color: ${(0, ui_theme_1.fromTheme)('color_button')};
    &:hover {
      color: ${(0, ui_theme_1.fromTheme)('color_button_hover')};
      background-color: transparent;
    }
  }
`;
//# sourceMappingURL=Checkbox.styles.js.map